/** Preset worker roles for AI Studio agent hire/edit combobox. */
export const AI_AGENT_ROLE_PRESETS = [
  'System Architect',
  'Tech Lead',
  'Product Manager',
  'Frontend Engineer',
  'Backend Engineer',
  'Full Stack Engineer',
  'QA Automation Engineer',
  'DevOps & Release Manager',
  'Data Engineer',
  'Data Scientist / Analyst',
  'UI/UX Designer',
  'iGaming Operations Leader',
  'Regulatory & Compliance Manager',
  'Fraud & Risk Analyst',
  'Sportsbook Trading Manager',
  'VIP Account Manager',
  'Affiliate Marketing Manager',
  'CRM & Retention Specialist',
  'Customer Support Manager',
  'Payments & Gateway Specialist',
];
